import { render } from "./TimeSlotsManagement.vue?vue&type=template&id=921376e8&scoped=true"
import script from "./TimeSlotsManagement.vue?vue&type=script&lang=js"
export * from "./TimeSlotsManagement.vue?vue&type=script&lang=js"

import "./TimeSlotsManagement.vue?vue&type=style&index=0&id=921376e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921376e8"]])

export default __exports__